<template>
	<section class="flightPath will-change h-[67vh] mx-content" :data-scroll-section="inner == 'false'">
		<!-- map -->
		<div class='custom-popup rounded-lg' id="map" style="height: 100%;"></div>
		<!-- map -->
		<div class="flex items-center " ref="popup">
			<!-- <span>{{distance}} km</span> -->
			<img
				v-show="time"
				:src="this.endpoints.template_url + '/assets/img/flight-icon.png'"
				:alt="'flight-icon'"
			/>
			<span class="ml-1 text-small text-white" v-show="time"> {{ time }}</span>
		</div>


		<div class="absolute bottom-8 left-1/2 -translate-x-1/2 bg-white bg-opacity-90 rounded text-xs text-center px-10 py-5 whitespace-nowrap">
			<!-- <span v-if="!isMobile">{{ __('Hover over city to view flight duration', 'ccave') }}</span> -->
			<span>{{ __('Click on the interest point or zoom in to view more', 'ccave') }}</span>
		</div>
	</section>
</template>

<script>
import mapboxgl from "mapbox-gl"
import "mapbox-gl/dist/mapbox-gl.css"
import distance from "@turf/distance"
export default {
	name: "FlightMap",
	data() {
		return {
			distance: false,
			time: false,
			customFont: false
		};
	},
	mounted() {
		
		
		mapboxgl.accessToken = this.blockData.flight_points.map_settings.access_token;
		const map = new mapboxgl.Map({
			container: "map", // container ID
			/* style: this.blockData.flight_points.map_settings.style, */ // style URL
			style: 'mapbox://styles/aleksandarstojsin/ckvqetdww39pn14pd9wi9smdp',
			center: this.blockData.flight_points.map_settings.center, // starting position
			zoom: this.blockData.flight_points.map_settings.zoom, // starting zoom
			pitch: this.blockData.flight_points.map_settings.pitch,
			bearing: this.blockData.flight_points.map_settings.bearing,
			cooperativeGestures: true,
            attributionControl: false
		});
		
		map.on("load", () => {
			this.blockData.flight_points.markers.forEach((marker, index) => {
				let mapData = JSON.parse(marker.map_data);
				let pointIcon =
					index == 0
						? this.endpoints.template_url + "/assets/img/circle-red.png"
						: this.endpoints.template_url + "/assets/img/dot-circle-black.png";

				map.loadImage(pointIcon, (error, image) => {
					if (error) throw error;
					map.addImage("custom-marker" + index, image);

					map.addSource("points" + index, {
						type: "geojson",
						data: mapData
					});

					map.addLayer({
						id: "points" + index,
						type: "symbol",
						source: "points" + index,
						layout: {
							"icon-image": "custom-marker" + index,
							"text-field": marker.name,
							"text-font": index === 0 ? ["Canela Regular", "Open Sans Semibold", "Arial Unicode MS Bold"] : ["Open Sans Semibold", "Arial Unicode MS Bold"],
							"text-offset": index === 0 ? [0, 1] : [1, 0],
							"text-anchor": index === 0 ? "top" : "left",
                            "text-justify": index === 0 ? "center" : "left"
						},
						paint: {
							"text-color": index == 0 ? "red" : "black"
						}
					});

					map.on("styleimagemissing", e => {
						if (e.id === pointIcon) {
							map.loadImage(pointIcon, (error, image) => {
								if (error) throw error;
								if (!map.hasImage(e.id)) map.addImage(e.id, image);
								/* map.getSource('markers').setData(this.endpoints.template_url + '/assets/img/dot-circle-black.png'); */
							});
						}
					});
				});

                // ROUTE LINES
				map.addSource("route"+index, {
					type: "geojson",
					data: {
						type: "Feature",
						properties: {},
						geometry: {
							type: "LineString",
							coordinates: [
								mapData.geometry.coordinates,
								JSON.parse(this.blockData.flight_points.markers[0].map_data).geometry.coordinates,
							]
						}
					}
				});

                // ROUTE LINES STYLE
				map.addLayer({
					id: "route"+index,
					type: "line",
					source: "route"+index,
					layout: {
						"line-join": "round",
						"line-cap": "round"
					},
					paint: {
						"line-color": "#BFBFBF",
                        "line-opacity": 0.5,
						"line-width": 2,
                        "line-dasharray": [ 1, 2 ]
					}
				});

                // POPUP
				const popup = new mapboxgl.Popup({
					closeButton: false,
					closeOnClick: true,
					offset: [0, -15]
				});
				popup.addClassName('trt');

                // MOUSE HOVER
				map.on("click", "points" + index, e => {
					if (index > 0) {
						map.getCanvas().style.cursor = "pointer";
						var from = mapData.geometry.coordinates;
                        map.setPaintProperty('route'+index, 'line-color', '#F16364');

						var to = JSON.parse(
							this.blockData.flight_points.markers[0].map_data
						).geometry.coordinates;
						var options = { units: "kilometers" };

						var flightDistance = distance(from, to, options);
						this.distance = Math.floor(flightDistance);
						this.time = marker.flight_time;

						popup
							.setLngLat(from)
							/* .setHTML(Math.floor(flightDistance) + ' km') */
							.setDOMContent(this.$refs.popup)
							.addTo(map);
					}
				});

				map.on("mousemove", "points" + index, e => {
					if (index > 0) {
						map.getCanvas().style.cursor = "pointer";
					}
				});

				map.on("mouseleave", "points" + index, () => {
					map.getCanvas().style.cursor = "";
				})

				popup.on('close', function(e) {
					map.getCanvas().style.cursor = "";
                    map.setPaintProperty('route'+index, 'line-color', '#BFBFBF');
				})

			});
		});
		map.scrollZoom.disable();
		map.addControl(new mapboxgl.NavigationControl());
	},
	methods: {}
};
</script>
